import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Spot } from '../models';
import { environment } from 'src/environments/environment';
import { BaseApiService } from './baseApiService';
import { StorageKey } from './storage.service';

@Injectable({
  providedIn: 'root'
})
export class SpotService extends BaseApiService<Spot> {
  get cacheKey(): StorageKey {
    return StorageKey.spotServiceCache;
  }

  getUrl(operation: string, params, id: string = null): string {
    let url = `${environment.apiUrl}/spots`;
    if (id != null) {
      url = url + '/' + encodeURIComponent(id);
    }
    return url;
  }

  protected unparse(obj) {
    return Spot.unparse(obj);
  }

  protected parse(obj) {
    return Spot.parse(obj);
  }
}
